import { NavigateOptions,useNavigate } from "react-router-dom";
import { V2_PAGES_REGEXES } from "utils/versions";

export const useVersionSensitiveNavigate = () => {
  const navigate = useNavigate();

  return (to: string, options?: NavigateOptions) => {
    return navigate(to, options);
  };
};